<template>
  <div class="activity-settings-button d-inline">
    <f7-icon f7="gear_alt" tooltip="Instellingen"
             @click.prevent.stop.self="onShowActivitySettings"
    ></f7-icon>
    <activity-settings-sheet-modal
      :show="showActivitySettings"
      @closed="showActivitySettings = false"

      :activity="activity"
      :training_session="training_session"
    ></activity-settings-sheet-modal>
  </div>
</template>

<script>
  import ActivityNotesSheetModal from "./ActivityNotesSheetModal.vue";
  import ActivitySettingsSheetModal from "./ActivitySettingsSheetModal.vue";

  export default {
    components: {
      ActivitySettingsSheetModal,
      ActivityNotesSheetModal
    },

    props:{
      activity: {},
      always_visible: {default: false}
    },

    mixins: [],

    data: function () {
      return {
        showActivitySettings: false,
      };
    },

    computed: {
      training_session() {
        return this.$store.getters['training_sessions/find'](this.activity.training_session_id);
      },
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      onShowActivitySettings() {
        this.showActivitySettings = true;
      }
    },

    watch: {
      //
    }
  };
</script>
